// src/components/SystemMuteToast/SystemMuteToast.tsx
import React from 'react';
import { Snackbar, Button, makeStyles, IconButton } from '@material-ui/core';
import MicOffIcon from '../../icons/MicOffIcon';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  snackbar: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: '#323232', // Google Meet dark background
      color: 'white',
      fontSize: '14px',
      fontWeight: 400,
      padding: '6px 16px',
      borderRadius: '4px',
      minWidth: '344px',
      maxWidth: '568px',
      flexWrap: 'nowrap',
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
  },
  micIcon: {
    fontSize: '20px',
    color: '#f9ab00', // Google Meet warning yellow
  },
  message: {
    flex: 1,
    lineHeight: '20px',
  },
  learnMoreButton: {
    color: '#8ab4f8', // Google Meet blue link color
    textTransform: 'none',
    padding: '4px 8px',
    minWidth: 'auto',
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'rgba(138, 180, 248, 0.08)',
    },
  },
  closeButton: {
    color: 'rgba(255, 255, 255, 0.7)',
    padding: '4px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  closeIcon: {
    fontSize: '18px',
  },
}));

interface SystemMuteToastProps {
  open: boolean;
  onClose: () => void;
  onLearnMore: () => void;
  deviceType: 'microphone' | 'camera';
}

export function SystemMuteToast({ open, onClose, onLearnMore, deviceType }: SystemMuteToastProps) {
  const classes = useStyles();

  const message =
    deviceType === 'microphone'
      ? 'Your mic is muted by your system settings. Click the mic to learn more.'
      : 'Your camera is blocked by your system settings. Click the camera to learn more.';

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={8000} // 8 seconds like Google Meet
      onClose={onClose}
      className={classes.snackbar}
      message={
        <div className={classes.content}>
          <MicOffIcon />
          <span className={classes.message}>{message}</span>
          <Button className={classes.learnMoreButton} onClick={onLearnMore} size="small">
            Learn more
          </Button>
        </div>
      }
      action={
        <IconButton className={classes.closeButton} onClick={onClose} size="small">
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      }
    />
  );
}
